<div class="sokeboks" (keyup)="handterTastehendelse($event)">
    <div class="sokefelt" [class.viser-resultater]="viserResultater()">
        <input matInput type="search" autocomplete="off" [formControl]="sokestreng" (focus)="visResultater()"
               [placeholder]="'søk' | translate" data-testid="sokefelt">
        <span class="ion-ios-search" aria-hidden="true"></span>
    </div>

    @if (viserResultater()) {
        <div class="resultatkontainer">
            <section class="resultat">
                @if (resultat(); as soekeresultat) {
                    @if (soekeresultat.hits.total > 0) {
                        <div class="resultathode">{{ 'Viser opp til 50 mest relevante treff. Spiss søket ditt med flere søkeord for å øke relevansen.' | translate }}</div>
                    } @else {
                        <div class="resultathode">{{ 'Ingen treff' | translate }}</div>
                    }
                } @else {
                    <div class="resultathode">{{ 'Søk etter brukere, grupper, medlemmer.' | translate }}</div>
                }

                @if (!valgErAktive()) {
                    <button type="button" class="lenke" (click)="byttVisningAvValg()">{{ 'Begrens søket til typer' | translate }}</button>
                } @else {
                    <button type="button" class="lenke" (click)="nullstillValg()">{{ 'Nullstill begrensninger' | translate }}</button>
                }

                @if (resultat(); as soekeresultat) {
                    @if (soekeresultat.hits.total > 0) {
                        <div class="resultatinnhold">
                            @for (treff of soekeresultat.hits.hits; track treff._id) {
                                <button type="button" class="soeketreff e2e-søketreff" [attr.e2e-type]="treff._type" (click)="velgTreff(treff)">
                                    <span class="type">{{ treffType(treff) | translate }}</span>
                                    <span class="tittel e2e-tittel">{{ treffTittel(treff) }}</span>
                                    <span class="beskrivelse">{{ treffBeskrivelse(treff) }}</span>
                                </button>
                            }
                        </div>
                        <footer>
                            <span>{{ '{antall} treff' | translate:{antall: soekeresultat.hits.total} }}</span>
                            <button type="button" class="lenke" (click)="skjulResultater()">{{ 'avbryt' | translate }}</button>
                        </footer>
                    }
                }
            </section>

            @if (viserValg()) {
                <aside class="valg">
                    <mat-checkbox [checked]="alleEntiteterValgt()" [indeterminate]="!alleEntiteterValgt() && !ingenEntiteterValgt()" (change)="byttAlleEntiteter()">
                        {{ 'Typer' | translate }}
                    </mat-checkbox>
                    @for (entitet of sokbareEntiteter; track entitet.type) {
                        <mat-checkbox [formControl]="entitet.kontroll">{{ entitet.navn | translate }}</mat-checkbox>
                    }
                </aside>
            }
        </div>
    }
</div>
